/* eslint-disable no-case-declarations */
import { Fragment } from 'react';
import { Row, Col, Container, Stack } from 'react-bootstrap';
import * as _ from 'lodash';
import {
  MarketIdToMarketName,
  ReverseName,
  OutcomeName,
  emptyMarketLabels,
  getFootballOddTypeText,
  checkHasMarketVariable,
  isMaradonaSpecifier
} from 'toolkit/utils';
import { AWS_BUCKET_URL } from 'toolkit/constants';
import { EnumMarketName } from 'toolkit/Enums.js';
import BetBox from './bet_box';
import MaradonaSpecifierBadge from './MaradonaSpecifierBadge';
import { useMediaQuery } from 'react-responsive';
import { useLocation } from 'react-router-dom';

function BetTitleAndBox(props) {
  const { market, marketId, matchId, hideMarketLabel, betBuilderIcon } = props;
  const location = useLocation();
  const isDesktop = useMediaQuery({
    query: '(min-width: 992px)'
  });
  function compareById(a, b) {
    return parseInt(a.id) - parseInt(b.id);
  }

  function getMarkets() {
    // const oddsSize = market.outcomes?.length === 2 ? 6 : 4;
    const oddsSize = 4;

    let sortedOutcomes;
    if (market.id == EnumMarketName.WINNERBOTHTEAMSTOSCORE_35) {
      const outcomeIds = ['78', '82', '86', '80', '84', '88'];
      sortedOutcomes = outcomeIds
        .map((id) => market.outcomes.find((o) => o.id === id))
        .filter((o) => o !== undefined);
    } else {
      sortedOutcomes = [...(market.outcomes || [])].sort(compareById);
    }

    //TODO market.id is not string!!!! it is number below cases is not working, check if we realy need cases
    switch (market.id) {
      case EnumMarketName.NEXTGOAL_8:
        const nextGoalOutcomeCount = market.outcomes?.length || 0;
        const nextGoalEqualSizeCol = props.hideMarketNameInCard && nextGoalOutcomeCount > 0
          ? Math.floor(12 / nextGoalOutcomeCount)
          : 4;

        if (isDesktop && hideMarketLabel) {
          const nextGoalColSize = market.outcomes.length === 2 ? 6 : 4;
          return (
            <div className="d-flex align-items-center w-100">
              <Row className="gx-2 flex-grow-1">
                {_.orderBy(market.outcomes, ['id'], ['asc']).map((outcome, index) => (
                  <Col
                    key={market.id + ' ' + (outcome.id || matchId + '' + index)}
                    xs={nextGoalColSize}>
                    <BetBox
                      providerId={matchId}
                      outcomeId={outcome.id}
                      marketStringId={market.stringId}
                      sport={props.sportType}
                      path={props.path}
                      showOddTitle={true}
                      showInlineTitle={false}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          );
        }

        return (
          <Container>
            <Row className="">
              {!hideMarketLabel && !props.hideMarketNameInCard && (
                <Col
                  xs={6}
                  className={`fs-8 d-flex align-items-center ${isDesktop ? 'text-white' : 'text-dark'
                    }`}>
                  <span className="d-inline-flex align-items-center">
                    {MarketIdToMarketName(market.id, market.stringId)}
                    {betBuilderIcon}
                  </span>
                </Col>
              )}
              <Col xs={hideMarketLabel || props.hideMarketNameInCard ? 12 : 6}>
                <Row className="gy-2 gx-1">
                  {_.orderBy(market.outcomes, ['id'], ['asc']).map((outcome, index) => (
                    <Col
                      xs={nextGoalEqualSizeCol}
                      className=""
                      key={market.id + ' ' + (outcome.id || matchId + '' + index)}>
                      <BetBox
                        providerId={matchId}
                        outcomeId={outcome.id}
                        marketStringId={market.stringId}
                        sport={props.sportType}
                        path={props.path}
                        showOddTitle={!props.hideMarketNameInCard}
                        showInlineTitle={props.hideMarketNameInCard}
                      />
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Container>
        );
      case EnumMarketName.NEXTGOALSCORER_38:
      case EnumMarketName.LASTGOALSCORER_39:
      case EnumMarketName.ANYTIMEGOALSCORER_40:
        return (
          <Stack direction="horizontal" gap={1}>
            {market.outcomes
              .filter((o) => o.odds !== 0)
              .map((outcome, index) => (
                <Col
                  key={market.id + ' ' + (outcome.id || matchId + '' + index)}
                  xs={2}
                  className=" float-end">
                  <BetBox
                    providerId={matchId}
                    outcomeId={outcome.id}
                    marketStringId={market.stringId}
                    showOddTitle={false}
                    sport={props.sportType}
                    path={props.path}
                  />
                </Col>
              ))}
          </Stack>
        );
      case EnumMarketName.CORRECTSCORE_41:
        const homeScore = [];
        const draw = [];
        const awayScore = [];
        market.outcomes.forEach((outcome, index) => {
          const outcomeName = outcome.name.split(':');
          const targetArray =
            Number(outcomeName[0]) > Number(outcomeName[1])
              ? homeScore
              : outcomeName[0] === outcomeName[1]
                ? draw
                : awayScore;
          targetArray.push(
            <Stack
              key={market.id + ' ' + (outcome.id || matchId + '' + index)}
              // gap={1}
              className="flex-grow-0">
              <BetBox
                providerId={matchId}
                outcomeId={outcome.id}
                marketStringId={market.stringId}
                sport={props.sportType}
                path={props.path}
                betBox={props.betBox}
                showOddTitle={!props.hideMarketNameInCard}
                showInlineTitle={props.hideMarketNameInCard}
              />
            </Stack>
          );
        });
        return (
          <>
            {!props.hideMarketNameInCard && (
              <Col
                className={`fs-8 d-flex align-items-center ${isDesktop ? 'text-white' : 'text-dark'
                  }`}
                xs={6}>
                {MarketIdToMarketName(market.id, market.stringId).split(' + ')[0]}
                {betBuilderIcon}
              </Col>
            )}
            <Col xs={props.hideMarketNameInCard ? 12 : 6}>
              <Container>
                <Row className="gx-1">
                  <Col xs={4} className={'d-flex flex-column gap-2'}>
                    {homeScore}
                  </Col>
                  <Col xs={4} className={'d-flex flex-column gap-2'}>
                    {draw}
                  </Col>
                  <Col xs={4} className={'d-flex flex-column gap-2'}>
                    {awayScore}
                  </Col>
                </Row>
              </Container>
            </Col>
          </>
        );
      // case EnumMarketName.CORRECTSCORE_41:
      //   return (
      //     <Container>
      //       <Row className="">
      //         <Col xs={6} className="text-dark fs-7">
      //           <div className="mb-1">&nbsp;</div>
      //           {MarketIdToMarketName(market.id, market.stringId).split(' + ')[0]}
      //         </Col>
      //         <Col xs={6}>
      //           <Row className="gy-2 gx-1 justify-content-end">
      //             {[...market.outcomes].sort(compareById).map((outcome, index) =>
      //               formatOdd(outcome?.odds) === '1.00' ? null : (
      //                 <Col
      //                   key={market.id + ' ' + (outcome.id || matchId + '' + index)}
      //                   xs={oddsSize}
      //                   className="">
      //                   <BetBox
      //                     providerId={matchId}
      //                     outcomeId={outcome.id}
      //                     marketStringId={market.stringId}
      //                     sport={props.sportType}
      //                     path={props.path}
      //                   />
      //                 </Col>
      //               )
      //             )}
      //           </Row>
      //         </Col>
      //       </Row>
      //     </Container>
      //   );
      case EnumMarketName.HALFTIMEFULLTIMETOTAL_818:
      case EnumMarketName.HALFTIMEFULLTIMEFIRSTHALFTOTAL_819:
        const groupedMarkets = _.values(
          _.groupBy(market.outcomes, (x) => {
            if (x.id >= 1845) return x.id;

            return Number(x.id) + 9;
          })
        );
        return (
          <Container>
            {!props.hideMarketNameInCard && (
              <Row className={`ps-2 mt-1 ${isDesktop ? 'text-white' : 'text-dark'}`}>
                {MarketIdToMarketName(market.id, market.stringId)}
                {betBuilderIcon}
              </Row>
            )}
            {groupedMarkets.map((outcome, index) => (
              <Row className="m-0" key={market.id + ' ' + (outcome.id || matchId + '' + index)}>
                {!props.hideMarketNameInCard && (
                  <Col
                    xs={6}
                    className={`ps-1 pe-1 text-center align-item-center justify-content-center pb-2 pt-0 mt-4 ${isDesktop ? 'text-white' : 'text-dark'
                      }`}>
                    {
                      getFootballOddTypeText(
                        market.id.toString(),
                        outcome[0].id.toString(),
                        outcome[0].name
                      ).split(' ')[0]
                    }
                  </Col>
                )}
                <Col xs={props.hideMarketNameInCard ? 12 : 6}>
                  <Row>
                    <Col xs={6} className="">
                      <BetBox
                        providerId={matchId}
                        outcomeId={outcome[0].id}
                        marketStringId={market.stringId}
                        showOddTitle={!props.hideMarketNameInCard}
                        showInlineTitle={props.hideMarketNameInCard}
                      />
                    </Col>
                    {outcome.length > 1 && (
                      <Col xs={6} className="">
                        <BetBox
                          providerId={matchId}
                          outcomeId={outcome[1].id}
                          marketStringId={market.stringId}
                          showOddTitle={!props.hideMarketNameInCard}
                          showInlineTitle={props.hideMarketNameInCard}
                        />
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            ))}
          </Container>
        );
      case EnumMarketName.HALFTIMEFULLTIMEEXACTGOALS_820:
        const groupedMarkets2 = _.values(
          _.groupBy(market.outcomes, (x) => {
            return x.name.split('&')[0];
          })
        );
        return (
          <Container>
            {!props.hideMarketNameInCard && (
              <Row
                className={`ps-2 mt-n3 d-flex align-items-center ${isDesktop ? 'text-white' : 'text-dark'
                  }`}>
                {MarketIdToMarketName(market.id, market.stringId)}
                {betBuilderIcon}
              </Row>
            )}
            {groupedMarkets2.map((outcome, index) => (
              <Fragment key={index}>
                <Row className="m-0">
                  {!props.hideMarketNameInCard && (
                    <Col
                      xs={6}
                      className={`ps-1 pe-1 text-center align-item-center justify-content-center mt-3 pt-0 ${isDesktop ? 'text-white' : 'text-dark'
                        }`}>
                      {
                        getFootballOddTypeText(
                          market.id.toString(),
                          outcome[0].id.toString(),
                          outcome[0].name
                        ).split(' ')[0]
                      }
                    </Col>
                  )}
                  <Col xs={props.hideMarketNameInCard ? 12 : 6}>
                    <Row className="gy-2 gx-1">
                      {outcome.map((outcomes, index1) => (
                        <Col
                          key={market.id + ' ' + (outcome.id || matchId + '' + index1)}
                          xs={4}
                          className="">
                          <BetBox
                            providerId={matchId}
                            outcomeId={outcomes.id}
                            marketStringId={market.stringId}
                            sport={props.sportType}
                            path={props.path}
                            showOddTitle={!props.hideMarketNameInCard}
                            showInlineTitle={props.hideMarketNameInCard}
                          />
                        </Col>
                      ))}
                    </Row>
                  </Col>
                </Row>
                {groupedMarkets2.length !== index + 1 ? <hr></hr> : null}
              </Fragment>
            ))}
          </Container>
        );
      case EnumMarketName.ANYTIMEGOALSCORERWINNER_888:
      case EnumMarketName.NEXTGOALSCORERWINNER_891:
        const scorerWinnerOutcomes = market.outcomes.filter((outcome) => outcome.id !== '1897');
        const scorerWinnerCount = scorerWinnerOutcomes.length || 0;
        const scorerWinnerEqualSizeCol = props.hideMarketNameInCard && scorerWinnerCount > 0
          ? Math.floor(12 / scorerWinnerCount)
          : oddsSize;
        return (
          <Container>
            <Row className="mb-1">
              {!props.hideMarketNameInCard && (
                <Col
                  xs={6}
                  className={`fs-8 d-flex align-items-center ${isDesktop ? 'text-white' : 'text-dark'
                    }`}>
                  {ReverseName(market.outcomes[0].name.split('&')[0])}
                </Col>
              )}
              <Col xs={props.hideMarketNameInCard ? 12 : 6}>
                <Row className="gy-2 gx-1">
                  {scorerWinnerOutcomes.map((outcome, index) => (
                    <Col
                      xs={scorerWinnerEqualSizeCol}
                      key={market.id + ' ' + (outcome.id || matchId + '' + index)}>
                      <BetBox
                        providerId={matchId}
                        outcomeId={outcome.id}
                        marketStringId={market.stringId}
                        sport={props.sportType}
                        path={props.path}
                        showOddTitle={!props.hideMarketNameInCard}
                        showInlineTitle={props.hideMarketNameInCard}
                      />
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Container>
        );
      default:
        const outcomeCount = sortedOutcomes?.length || 0;
        const equalSizeCol = props.hideMarketNameInCard && outcomeCount > 0
          ? 'auto'
          : (isDesktop && hideMarketLabel && sortedOutcomes.length === 2 ? 6 : oddsSize);

        const isMatchDetailPage = location.pathname.includes('/match-detail');
        const shouldUseMaradonaBadge = Boolean(props.isMaradonaHandicap || isMatchDetailPage);
        const isHandicapMarket = [
          EnumMarketName.HANDICAP_14,
        ].includes(market.id);
        // Get specifier for O/U and Handicap markets
        const shouldShowSpecifier = props.showSpecifier || (shouldUseMaradonaBadge && isHandicapMarket);
        const specifier = shouldShowSpecifier ? checkHasMarketVariable(market.id, market.stringId) : null;
        const isMaradonaHandicapSpecifier = isMaradonaSpecifier(market.stringId);
        const shouldRenderMaradonaSpecifier =
          shouldUseMaradonaBadge && isHandicapMarket && isMaradonaHandicapSpecifier;

        // Desktop live/prematch view with hideMarketLabel
        if (isDesktop && hideMarketLabel) {
          // Calculate column size based on number of outcomes
          const colSize = sortedOutcomes.length === 2 ? 6 : 4;
          return (
            <div className="d-flex align-items-center w-100">
              {market.id == EnumMarketName.TOTAL_18 && (
                <span className="bet-secondary text-warning me-2" style={{ minWidth: '2rem', textAlign: 'center' }}>
                  {OutcomeName(market.id, market.stringId, market.name)}
                  {betBuilderIcon}
                </span>
              )}
              <Row className="gx-2 flex-grow-1">
                {sortedOutcomes?.map((outcome, index) => (
                  <Col
                    key={market.id + ' ' + (outcome.id || matchId + '' + index)}
                    xs={colSize}>
                    <BetBox
                      providerId={matchId}
                      outcomeId={outcome.id}
                      marketStringId={market.stringId}
                      sport={props.sportType}
                      path={props.path}
                      showOddTitle={true}
                      showInlineTitle={false}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          );
        }

        return (
          <Container>
            <Row className="">
              {hideMarketLabel ? (
                market.id == EnumMarketName.TOTAL_18 && (
                  <Col xs={'auto'} className={` ${isDesktop ? 'mt-1-35' : 'mt-1'}`}>
                    <span className={'bet-secondary text-warning me-0'}>
                      {OutcomeName(market.id, market.stringId, market.name)}
                      {betBuilderIcon}
                    </span>
                  </Col>
                )
              ) : !props.hideMarketNameInCard ? (
                <Col
                  xs={6}
                  className={`fs-8 d-flex align-items-center ${isDesktop ? 'text-white' : 'text-dark'
                    }`}>
                  {OutcomeName(market.id, market.stringId, market.name)}
                  {betBuilderIcon}
                  {shouldRenderMaradonaSpecifier && (
                    <span className="ms-1">
                      {isMatchDetailPage ? (
                        <span className="d-inline-flex align-items-center gap-1">
                          <MaradonaSpecifierBadge specifier={specifier} iconOnly={true} />
                        </span>
                      ) : (
                        <MaradonaSpecifierBadge specifier={specifier} iconOnly={false} />
                      )}
                    </span>
                  )}
                </Col>
              ) : null}
              <Col xs={hideMarketLabel ? 'auto' : props.hideMarketNameInCard ? 12 : 6}>
                {props.hideMarketNameInCard ? (
                  <div className="d-flex align-items-center gap-1 mt-1">
                    {/* Only show specifier column if there's a specifier */}
                    {specifier && (
                      <div className="d-flex align-items-center justify-content-center" style={{ flexShrink: 0 }}>
                        {shouldRenderMaradonaSpecifier ? (
                          isMatchDetailPage ? (
                            <span className="d-inline-flex align-items-center gap-1">
                              <MaradonaSpecifierBadge specifier={specifier} iconOnly={true} />
                            </span>
                          ) : (
                            <MaradonaSpecifierBadge specifier={specifier} iconOnly={false} />
                          )
                        ) : (
                          <span className="fs-8 fw-semibold" style={{ color: '#AF021F', minWidth: '1.75rem', textAlign: 'center' }}>{specifier}</span>
                        )}
                      </div>
                    )}
                    {/* Buttons fill available space equally */}
                    <div className="d-flex flex-grow-1 gap-1">
                      {sortedOutcomes?.map((outcome, index) => (
                        <div
                          key={market.id + ' ' + (outcome.id || matchId + '' + index)}
                          style={{ flex: '1 1 0', minWidth: 0 }}>
                          <BetBox
                            providerId={matchId}
                            outcomeId={outcome.id}
                            marketStringId={market.stringId}
                            sport={props.sportType}
                            path={props.path}
                            showOddTitle={false}
                            showInlineTitle={true}
                          />
                        </div>
                      ))}
                    </div>
                    {/* Reserve space for market count on ALL rows for alignment */}
                    {props.marketCount && (
                      <div className="d-flex align-items-center" style={{ minWidth: '2.05rem', float: 'right' }}>
                        {props.isLastMarket && (
                          <>
                            <span className="text-dark fs-8">{props.marketCount}</span>
                            <img
                              style={{ width: '0.75rem', height: '0.75rem' }}
                              src={`${AWS_BUCKET_URL}/Icons/nexticon-caret.svg`}
                              alt=">"
                            />
                          </>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <Row className="gy-2 gx-1 justify-content-end mt-n2 align-items-center">
                    {sortedOutcomes?.map((outcome, index) => (
                      <Col
                        key={market.id + ' ' + (outcome.id || matchId + '' + index)}
                        xs={equalSizeCol}
                        className="d-flex flex-column">
                        <BetBox
                          providerId={matchId}
                          outcomeId={outcome.id}
                          marketStringId={market.stringId}
                          sport={props.sportType}
                          path={props.path}
                          showOddTitle={true}
                          showInlineTitle={false}
                        />
                      </Col>
                    ))}
                  </Row>
                )}
              </Col>
            </Row>
          </Container>
        );
    }
  }

  if (!market) {
    const emptyLabels = emptyMarketLabels(marketId);
    if (!emptyLabels || emptyLabels.length === 0) return <div></div>;
    return (
      <Row className="text-start">
        <Container>
          <Row className="align-items-center">
            <Col xs={'auto'}>
              <Row className="gy-2 gx-1">
                {emptyMarketLabels(marketId).map((marketLabel, index, arr) => (
                  <Col key={index} xs={12 / arr.length} className="">
                    <div className=" d-flex flex-column text-center">
                      {isDesktop ? '' : <span>{marketLabel}</span>}
                      {isDesktop ? (
                        <div
                          className="border-tertiary rounded justify-content-center text-dark px-1 d-inline-flex w-100 fw-bold mt-auto pt-1 pb-1 fs-8"
                          style={{ backgroundColor: '#696767' }}>
                          <img
                            className="icon-white"
                            width="17"
                            height="18"
                            style={{ width: '2.05rem' }}
                            src={`${AWS_BUCKET_URL}/Icons/lockicon.svg`}
                          />
                        </div>
                      ) : (
                        <div className="flex-center border-gray-300 rounded text-center px-1 py-1 w-100 fw-bold light-black-svg mt-auto fs-8">
                          <img
                            width="17"
                            height="18"
                            src={`${AWS_BUCKET_URL}/Icons/lockicon.svg`}
                          />
                        </div>
                      )}
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </Row>
    );
  }

  return <Row>{market && getMarkets()}</Row>;
}

export default BetTitleAndBox;
